export default __webpack_public_path__ + "static/media/cp_geo_af.03412c91.svg";